import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Landing from "./pages/Landing";
import LegalPage from "./pages/LegalPage";
import Onboarding from "./pages/Onboarding";
import AdminPanel from "./pages/AdminPanel";
import KycResubmit from "./pages/KycResubmit";
import MerchantPortal from "./pages/MerchantPortal";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/registro" element={<Onboarding />} />
          <Route path="/secureportal" element={<AdminPanel />} />
          <Route path="/reenvio/:token" element={<KycResubmit />} />
          <Route path="/mi-cuenta" element={<MerchantPortal />} />
          <Route path="/terminos-y-condiciones" element={<LegalPage type="terms" />} />
          <Route path="/politicas-de-privacidad" element={<LegalPage type="privacy" />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
